import DualListView from "../components/DualListView";

export default class DigitalJobsClientLibrary {
  constructor(params) {
    this.params = params;
    this.role = params.role || null;
  }

  index() {
    new DualListView({ roleType: this.role, initial: "module" });
  }
}
